<p class="ms-2">Periode: </p>
<app-date-picker-dk
    class="ms-2"
    id="fra"
    #fraPicker="ngModel"
    name="fra"
    [maxDate]="tilPicker.value | ngbDateStruct"
    (ngModelChange)="onFraChange($event, fraPicker.valid)"
    [ngModel]="periode?.fra"></app-date-picker-dk>

<app-date-picker-dk
    class="ms-2"
    id="til"
    #tilPicker="ngModel"
    name="til"
    [endOfDay]="true"
    [minDate]="fraPicker.value | ngbDateStruct"
    (ngModelChange)="onTilChange($event, tilPicker.valid)"
    [ngModel]="periode?.til"></app-date-picker-dk>
